import { Dialog } from 'primereact/dialog';
import { ModalProps } from '../../_models/modal-props';

export function SubmitSuccess(props: ModalProps) {
    return (
        <Dialog draggable={false} blockScroll={true} visible style={{ width: '50vw' }} onHide={props.onHide}
            header={
                <div className="text-uppercase">
                    <i className="fas fa-file-plus h4 mb-0 mr-2 px-1"></i> Contribute Content
                </div>
            }
            footer={
                <button aria-label="Close dialog" className="btn btn-secondary text-uppercase" type="button"
                    onClick={props.onHide}>
                    Close
                </button>
            }
        >
            <div className="d-flex justify-content-start align-items-center">
                <i className="fad fa-check-circle text-success fa-3x mr-4"></i>
                <span className="text-success"><b>Thank you for sharing</b><br /> Your contribution has been saved.  Check your inbox for a confirmation email.</span>
            </div>
        </Dialog>
    );
}
